// (B) antd 파리티 토스트 아이콘 — message/notification 의 success/info/warning/error 컬러 아이콘.
// antd 는 흰 배경 + 컬러 filled 아이콘(CheckCircleFilled 등)만 쓴다(sonner richColors 의 배경틴트 아님).
// sonner <Toaster icons={...}> 로 주입 → 모든 토스트가 antd 와 동일한 아이콘을 사용.
import type { ReactNode } from 'react'

// antd v5 상태 색상 토큰.
const COLORS = {
  success: '#52c41a',
  info: '#1677ff',
  warning: '#faad14',
  error: '#ff4d4f',
} as const

// antd @ant-design/icons filled 아이콘의 path(viewBox 0 0 1024 1024) 를 그대로 사용해 형태를 일치시킨다.
const PATHS = {
  // CheckCircleFilled
  success:
    'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z',
  // CloseCircleFilled
  error:
    'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z',
  // InfoCircleFilled
  info: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z',
  // ExclamationCircleFilled
  warning:
    'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z',
} as const

type ToastType = keyof typeof COLORS

function Icon({ type }: { type: ToastType }): ReactNode {
  return (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill={COLORS[type]} aria-hidden="true">
      <path d={PATHS[type]} />
    </svg>
  )
}

// sonner Toaster icons prop 용.
export const toastIcons = {
  success: <Icon type="success" />,
  info: <Icon type="info" />,
  warning: <Icon type="warning" />,
  error: <Icon type="error" />,
}
